import React from "react";
import i18n from "../../../i18n";
import { Spinner, Callout } from "@blueprintjs/core";
import { Trans } from "react-i18next";
import PieChart from "../../Charts/PieChart";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";

function DeviceUsage(props) {
  const labels = [];
  const values = [];

  for (const device of props.distribution) {
    labels.push(device.device);
    values.push(device.event_count);
  }

  return <PieChart labels={labels} data={values} title={i18n.t(props.type)} />;
}

export default class DeviceMostUsed extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      labels: [],
      loading: false,
    };
  }

  componentDidMount() {
    if (this.props.urlsearchparams !== undefined) {
      this.setState({ loading: true }, () => {
        authenticatedGetFetch(
          "/activity/devicemostused?" + this.props.urlsearchparams,
          (res) => {
            this.setState({
              data: res,
              loading: false,
            });
          }
        );
      });
    }
  }

  render() {
    const perType = [];
    this.state.data.forEach((datafortype) => {
      perType.push(<DeviceUsage key={datafortype.type} {...datafortype} />);
    });

    return !this.props.urlsearchparams ? null : (
      <Callout
        title={<Trans>distribution of equipment use</Trans>}
        icon="chart"
      >
        {this.state.loading ? (
          <Spinner />
        ) : this.state.data !== undefined && this.state.data.length > 0 ? (
          <div className="flexbox-center">{perType}</div>
        ) : (
          <Callout intent="primary">
            <Trans>no data for the period</Trans>
          </Callout>
        )}
      </Callout>
    );
  }
}
